<template>
    <div class="pop-up">
        <!-- 固定表单 -->
        <el-form v-if="whethertocustomize" :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="图书证号：" prop="className" v-if="showlibraryregistration">
                <div style="display:flex ; align-items: center; margin-bottom: 10px;">
                    <img :src="showlibraryregistrationinfo" alt="" style="width: 150px;height: 150px; ">
                    <span style="margin-left:10px ;">(请先扫码注册图书证号，填入下方输入框)</span>
                </div>
                <Input v-model="form.registration" type="text" placeholder="请填写图书证号"></Input>
            </el-form-item>
            <el-form-item label="真实姓名：" prop="userName">
                <Input v-model="form.userName" type="text"></Input>
            </el-form-item>
            <el-form-item label="手机号码：" prop="tel">
                <Input v-model="form.tel" type="text"></Input>
            </el-form-item>
            <el-form-item :label="text+'：'" prop="department">
                <Input v-model="form.department" type="text" :placeholder="tishi"></Input>
            </el-form-item>
            <el-form-item :label="text2+'：'" prop="className">
                <Input v-model="form.className" type="text" :placeholder="tishi2"></Input>
            </el-form-item>
        </el-form>

        <!-- 动态表单 -->
        <el-form v-else :model="dynamicForm" :rules="dynamicRules" ref="dynamicForm" label-width="100px">
            <el-form-item v-for="(field, index) in dynamicFields" :key="index" :label="field.label + '：'"
                :prop="field.prop" :rules="dynamicRules[field.prop]">
                <!-- 输入框 -->
                <el-input v-if="field.type == 'input'" v-model="dynamicForm[field.prop]"
                    :type="field.inputType || 'text'" :placeholder="field.placeholder"></el-input>

                <!-- 下拉框 -->
                <el-select v-else-if="field.type === 'select'" v-model="dynamicForm[field.prop]"
                    :placeholder="field.placeholder">
                    <el-option v-for="opt in field.options" :key="opt.value" :label="opt.label" :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <div class="btn_box" style="text-align:center;">
            <el-button class="btn_add_sure" @click="handleSubmit" type="primary">提 交</el-button>
        </div>
    </div>
</template>

<script>
    import { Form, FormItem, Input, Button, Select, Option } from 'element-ui'
    import Cookies from 'js-cookie'
    import {
        editPersonInfo,
        userList,
        submitForm,       // 新增接口：获取表单类型
        getDynamicFields   // 新增接口：获取动态字段
    } from '@/api/manage.js'
    import { showindependently } from '@/api/pages'

    export default {
        name: 'ImproveInfo',
        components: { Form, FormItem, Input, Button, Select, Option },
        data() {
            return {
                // 固定表单相关
                whethertocustomize: true,
                text: '行业',
                text2: '区域',
                tishi: '如：互联网',
                tishi2: '如：朝阳区',
                form: {
                    userId: JSON.parse(localStorage.getItem('user')).gid,
                    registration: '',
                    userName: '',
                    tel: '',
                    department: '',
                    className: ''
                },
                rules: {
                    registration: [{ required: true, message: '请输入注册结果', trigger: 'blur' }],
                    userName: [
                        { required: true, message: '请输入真实姓名', trigger: 'blur' },
                        { validator: this.checkUserName, trigger: 'blur' }
                    ],
                    tel: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                    ],
                    department: [{ required: true, message: '请输入行业...', trigger: 'blur' }],
                    className: [{ required: true, message: '请输入区域...', trigger: 'blur' }]
                },
                showlibraryregistration: false,
                showlibraryregistrationinfo: '',

                // 动态表单相关
                dynamicForm: {},
                dynamicRules: {},
                dynamicFields: []
            }
        },
        async created() {
            let data = {
                orgGid: JSON.parse(localStorage.getItem('user')).orgGid,
                userId: JSON.parse(localStorage.getItem('user')).gid
            }
            const fieldRes = await getDynamicFields(data)
            if (fieldRes.data.length <= 0) {
                this.whethertocustomize = true
            } else {
                this.whethertocustomize = false
                this.dynamicFields = this.transformFields(fieldRes.data)
                this.initDynamicForm()
            }
            console.log(fieldRes, 'fieldRes');
            // 原有初始化
            this.getPersonInfo()
            this.libraryregistration()

            // 初始化文本提示
            const userType = JSON.parse(localStorage.getItem('user')).libType
            this.text = userType == '公共馆' ? '行业' : '院系'
            this.text2 = userType == '公共馆' ? '区域' : '班级'
            this.tishi = userType == '公共馆' ? '如：互联网' : '如：计算机系'
            this.tishi2 = userType == '公共馆' ? '如：朝阳区' : '如：23级软件1班'
            this.rules.department[0].message = `请输入${this.text}...`
            this.rules.className[0].message = `请输入${this.text2}...`
        },
        methods: {
            // 新增字段转换方法
            transformFields(apiFields) {
                const userType = JSON.parse(localStorage.getItem('user')).libType
                return apiFields.filter(f => f.is_visible).map(field => {
                    try {
                        const options = JSON.parse(field.default_options)
                        const isPublic = userType == '公共馆'

                        return {
                            field_id: field.field_id,  // 保留原始field_id
                            prop: field.field_name,
                            label: field.display_name.replace(/：$/, ''),
                            type: this.mapFieldType(field.field_type),
                            placeholder: field.placehoder,
                            field_value: field.field_value,  // 添加字段值
                            rules: this.generateRules(field)
                        }
                    } catch (e) {
                        console.error('Field transform error:', e)
                        return null
                    }
                }).filter(Boolean) // 过滤无效字段
            },

            mapFieldType(type) {
                const typeMap = {
                    text: 'input',
                    select: 'select',
                    number: 'input'
                }
                return typeMap[type] || 'input'
            },
            // 生成校验规则
            generateRules(field) {
                const rules = []

                // 必填规则
                if (field.custom_required) {
                    rules.push({
                        required: true,
                        message: `${field.display_name.replace('：', '')}不能为空`,
                        trigger: 'blur'
                    })
                }

                // 特殊字段校验（添加方法引用）
                switch (field.field_name) {
                    case 'tel':
                        rules.push({
                            pattern: /^1[3456789]\d{9}$/,
                            message: '手机号格式不正确',
                            trigger: 'blur'
                        })
                        break
                    case 'userName':
                        rules.push({
                            validator: 'checkUserName', // 使用方法名引用
                            trigger: 'blur'
                        })
                        break
                }

                return rules
            },
            // 修改初始化动态表单方法
            // 修改initDynamicForm方法
            initDynamicForm() {
                const form = { ...this.form } // 保留原始数据
                const rules = {}

                this.dynamicFields.forEach(field => {
                    // 优先使用后端返回的字段值
                    if (field.field_value !== undefined) {
                        form[field.prop] = field.field_value
                    }
                    // 如果字段不存在则初始化
                    if (!(field.prop in form)) {
                        form[field.prop] = ''
                    }

                    // 生成校验规则
                    if (field.rules) {
                        rules[field.prop] = field.rules.map(rule => {
                            const baseRule = { ...rule }
                            // 处理正则表达式
                            if (rule.pattern) {
                                baseRule.pattern = new RegExp(rule.pattern)
                            }
                            // 处理自定义验证器
                            if (rule.validator) {
                                baseRule.validator = this[rule.validator] // 确保方法存在
                            }
                            return baseRule
                        })
                    }
                })

                this.dynamicForm = form
                this.dynamicRules = rules
                console.log('Dynamic Form:', this.dynamicForm)
                console.log('Dynamic Rules:', this.dynamicRules)
            },



            // 修改提交方法
            async submitDynamicForm() {
                try {
                    const valid = await this.$refs.dynamicForm.validate()
                    if (!valid) return

                    // 获取用户信息
                    const user = JSON.parse(localStorage.getItem('user'))

                    // 构建符合要求的参数格式
                    const submitData = this.dynamicFields.map(field => ({
                        fieldId: field.field_id,  // 注意这里使用接口返回的field_id
                        fieldValue: this.dynamicForm[field.prop],
                        userId: user.gid,
                        clientId: user.orgGid
                    }))
                    const res = await submitForm(submitData)
                    if (res.status) {
                        localStorage.setItem('user', JSON.stringify(res.data))
                        Cookies.set("name", res.data.userName)
                        this.$emit('submit', res.data.userName)
                        // this.$store.commit('DataStorage/setUserInfo', {name: res.data.userName})
                        this.$message.success('修改成功！')
                    } else {
                        this.$message.error(res.errorMsg || '修改失败！')
                    }
                } catch (error) {
                    console.error('Submit error:', error)
                    if (error.errors) {
                        this.$message.error(error.errors[0].message)
                    } else {
                        this.$message.error('提交失败，请检查表单')
                    }
                }
            },
            handleSubmit() {
                if (this.whethertocustomize) {
                    console.log('Submit original form')
                    this.submitOriginalForm()
                } else {
                    console.log('Submit dynamic form')
                    console.log('Dynamic Form Ref:', this.$refs.dynamicForm)
                    this.submitDynamicForm()
                }
            },


            // 提交固定表单
            submitOriginalForm() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        editPersonInfo(this.form).then(res => {
                            if (res.status) {
                                this.updateUserInfo()
                                this.$emit('submit', this.form.userName)
                                // this.$store.commit('DataStorage/setUserInfo', {name: this.form.userName})
                                this.$message.success('修改成功！')
                            } else {
                                this.$message.error(res.errorMsg || '修改失败！')
                            }
                        }).catch(err => {
                            this.$message.error(err.message || '提交失败')
                        })
                    }
                })
            },
            // 原有方法保持不变
            checkUserName(rule, value, callback) {
                value === '自主注册用户'
                    ? callback(new Error('请输入真实姓名！'))
                    : callback()
            },

            async getPersonInfo() {
                try {
                    const res = await userList({ userId: this.form.userId })
                    if (res.status) {
                        const data = res.data.list[0]
                        this.form.userName = data.userName
                        this.form.tel = data.tel
                        this.form.department = data.department
                        this.form.className = data.className
                        this.form.registration = data.registration
                    }
                } catch (error) {
                    console.error('Error fetching user info:', error)
                }
            },

            async libraryregistration() {
                try {
                    const res = await showindependently({
                        orgGid: JSON.parse(localStorage.getItem('user')).orgGid
                    })
                    if (res.code == '200') {
                        this.showlibraryregistration = res.data.data.istsgqrcode
                        if (this.showlibraryregistration) {
                            this.showlibraryregistrationinfo = res.data.data.tsgqrcode
                        }
                    }
                } catch (error) {
                    this.$message.error('获取图书馆注册信息失败')
                }
            },

            updateUserInfo() {
                const user = JSON.parse(localStorage.getItem('user'))
                user.userName = this.form.userName
                user.tel = this.form.tel
                localStorage.setItem('user', JSON.stringify(user))
                Cookies.set("name", this.form.userName)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .pop-up {
        padding: 20px;
        max-width: 600px;
        margin: 0 auto;

        .el-form-item {
            margin-bottom: 22px;

            ::v-deep .el-form-item__label {
                font-weight: 500;
            }
        }

        .btn_box {
            margin-top: 30px;

            .el-button {
                padding: 12px 30px;
                font-size: 14px;
            }
        }

        img {
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 5px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/improveInfo.vue